import "@pjs/theming/dist/theme.css";
import { injectCss } from "../../../../../../../node_modules/@pebblepad/pebblepack/runtime/InjectCss.runtime.js";
injectCss(`.uui-select-duration-step__select-container{width:25rem;max-width:100%}`);